import { useMantineColorScheme, Checkbox } from "@mantine/core";
import PropTypes from "prop-types";
import { useDualTranslation } from "../utils/i18nHelpers";

const WeekdaysSelector = ({
  WEEK_DAYS,
  usedWeekdays,
  selectedSeason,
  activeDemandType,
  handleWeekdayClick,
}) => {
  // Get color scheme from Mantine
  const { colorScheme } = useMantineColorScheme();
  const { t } = useDualTranslation();

  return (
    <div className="row">
      <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
        <div className="row align-items-center mb-3">
          <label
            htmlFor="form-weekdays"
            className="mt-2"
            style={{ fontSize: "12px", fontWeight: "700" }}
          >
            {t("demandCharge.weekdays.select", {
              name: selectedSeason?.periods[activeDemandType]?.demandTypeName,
            })}
          </label>

          <div
            className="col-sm-9 d-flex flex-row justify-content-around mt-2"
            id="form-weekdays"
            style={{ maxWidth: "400px" }}
          >
            {WEEK_DAYS.map((day) =>  (
                <Checkbox
                  key={day.id}
                  label={<span className="font-10px line-spacing">{day.name}</span>}
                  checked={!!selectedSeason?.periods?.[activeDemandType]?.weekDays?.includes(day.id)}
                  disabled={usedWeekdays?.has(day.id)}
                  onChange={() => !usedWeekdays?.has(day.id) && handleWeekdayClick(day.id)}
                  size="lg"
                  color="green"
                  className={`display-weekdays-dc pointer ${usedWeekdays?.has(day.id) ? "pe-none diabled-avoid" : ""}`}
                  styles={{
                    body: { flexDirection: "column-reverse", alignItems: "center", cursor: usedWeekdays?.has(day.id) ? "not-allowed" : "pointer" },
                    label: { paddingLeft: "1px", order: -1, marginBottom: "6px" },
                  }}
                />
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
WeekdaysSelector.propTypes = {
  WEEK_DAYS: PropTypes.array,
  usedWeekdays: PropTypes.object,
  selectedSeason: PropTypes.object,
  activeDemandType: PropTypes.number,
  handleWeekdayClick: PropTypes.func,
};

export default WeekdaysSelector;
